module.exports = __webpack_public_path__ + "static/media/btc_card.797efc90.png";